module.exports = __webpack_public_path__ + "img/ic_add_photo.26099460.svg";